/* unplugin-vue-components disabled */import script from "./setting.vue?vue&type=script&setup=true&lang=js"
export * from "./setting.vue?vue&type=script&setup=true&lang=js"

import "./setting.vue?vue&type=style&index=0&id=bbeb0e92&lang=scss"

const __exports__ = script;

export default __exports__